import { useCallback, useLayoutEffect, useState } from 'react';

import HOURS_OPIONS from '../OccasionalAvailabilityCard/hoursOption';

import { TimeContainerProps } from './types';

import * as S from './styles';

const TimeContainer: React.FC<TimeContainerProps> = ({
  onChangeTime,
  ...rest
}) => {
  const [date, setDate] = useState<string>('');
  const [hour, setHour] = useState<string>('00:00');
  const handleChangeDate = useCallback(
    event => {
      let { value } = event.target;
      const valInd = value.length - 1;

      if (Number.isNaN(-value[valInd])) {
        value = value.substring(0, valInd);
      }

      setDate(value);
    },
    [setDate],
  );
  const handleKeyDownDate = useCallback(
    event => {
      let { value } = event.target;

      if (!(event.keyCode === 46 || event.keyCode === 8)) {
        if (value.length === 2 || value.length === 5) {
          value = `${value}/`;
        }
      }

      setDate(value);
    },
    [setDate],
  );
  const handleBlurDate = useCallback(
    event => {
      if (date.length === 10) {
        let { value } = event.target;

        value = value
          .split('/')
          .map((char: string, ind: number) => {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();

            const max: { [key: number]: number } = {
              0: 31,
              1: 12,
              2: currentYear + 1,
            };
            const newChar = +char;
            const maxResolved = max[ind];

            return newChar > maxResolved
              ? String(maxResolved).padStart(2, '0')
              : String(newChar).padStart(2, '0');
          })
          .join('/');

        setDate(value);
      }
    },
    [date, setDate],
  );
  const handleChangeHour = useCallback(
    event => setHour(event.value),
    [setHour],
  );

  useLayoutEffect(() => {
    onChangeTime({
      date,
      hour,
    });
  }, [date, hour, onChangeTime]);

  return (
    <S.TimeContainer>
      <S.DateInput
        full
        value={date}
        onChange={handleChangeDate}
        onKeyDown={handleKeyDownDate}
        onBlur={handleBlurDate}
        data-testid="dateInput"
        {...rest}
      />
      <S.TimeDropdown options={HOURS_OPIONS} onChange={handleChangeHour} full />
    </S.TimeContainer>
  );
};

export default TimeContainer;
